import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { SplendidCRMDFService } from './SplendidCRMDFService'

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private splendid: SplendidCRMDFService,
        private router: Router) { }

    canActivate() {
        const sessionToken = localStorage.getItem('session_token');
        if (!sessionToken) {
            this.router.navigate(['login']);
            return false;
        } else {
            this.splendid.setUserProfile(JSON.parse(localStorage.getItem('userProfile')));
            this.splendid.setIsLogued(true);
        }

        return true;
    }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/services/AuthGuardService.service.ts